module.exports = __webpack_public_path__ + "img/stamp-redeemed.c1ed920a.png";